import {ChangeDetectionStrategy, Component} from '@angular/core';
import {FormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';

import {InputPasswordComponent} from 'src/app/shared/components/inputs/input-password/input-password.component';
import {InputTextComponent} from 'src/app/shared/components/inputs/input-text/input-text.component';

import {AuthService} from 'src/app/core/services/auth.service';
import {PrimaryButtonComponent} from '../../buttons/primary-button/primary-button.component';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputTextComponent,
    InputPasswordComponent,
    PrimaryButtonComponent,
  ],
})
export class LoginFormComponent {
  hide = true;
  loginForm = this.fb.group({
    username: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required],
  });

  constructor(
    // private readonly authService: AuthService,
    private fb: FormBuilder
  ) {
  }

  public onLoginClick() {
    if (this.loginForm.value.username && this.loginForm.value.password) {
      // this.authService.login??
    }
  }
}
